import { useAssistance } from "../RootNavigator/services/Assistance";
import MyPaymentsScreen from "./MyPaymentsScreen";
import MyPaymentScreen from "./MyPaymentScreen";
import { Route, Switch } from "@hpo/client/utilities/Routing";
import { myPaymentRoute, myPaymentsRoute } from "@hpo/client/utilities/routes";

export default function MyPaymentsNavigator() {
  const assitance = useAssistance();
  assitance.useChatWithInstructor();
  return (
    <Switch>
      <Route destination={myPaymentsRoute} exact component={MyPaymentsScreen} />
      <Route destination={myPaymentRoute} component={MyPaymentScreen} />
    </Switch>
  );
}
